package com.cs.ejobin.model

import com.cs.ejobin.i18n.Keys

enum class SkillCatalog(
    val label: String,
    val labelKey: String
) {
    CHEF("Chef", Keys.skill_chef),
    COMMIS("Commis", Keys.skill_commis),
    SALLE("Salle", Keys.skill_salle),
    SERVEUR("Serveur", Keys.skill_serveur),
    CHEF_DE_RANG("Chef de rang", Keys.skill_chef_de_rang),
    PLONGEUR("Plongeur", Keys.skill_plongeur),
    CAISSIER("Caissier", Keys.skill_caissier),
    PATISSIER("Patissier", Keys.skill_patissier),
    PIZZAIOLO("Pizzaiolo", Keys.skill_pizzaiolo),
    SOUS_CHEF("Sous chef", Keys.skill_sous_chef),
    SOMMELIER("Sommelier", Keys.skill_sommelier),
    ELAGAGE("Élagage", Keys.skill_elagage),
    OUVRIER("Ouvrier", Keys.skill_ouvrier),
    MANOEUVRE("Manoeuvre", Keys.skill_manoeuvre),
    MACON("Maçon", Keys.skill_macon),
    CHARPENTIER("Charpentier", Keys.skill_charpentier),
    MENUISIER("Menuisier", Keys.skill_menuisier),
    FACADIER_ENDUISER("Façadier/Enduiser", Keys.skill_facadier_enduiseur),
    TERRASSIER("Terrassier", Keys.skill_terrassier),
    CONDUCTEUR_DENGINS("Conducteur d\"engins", Keys.skill_conducteur_dengins),
    ELECTRICIEN("Électricien", Keys.skill_electricien),
    PLOMBIER("Plombier", Keys.skill_plombier),
    CHAUFFAGISTE("Chauffagiste", Keys.skill_chauffagiste),
    CLIMATISATION("Climatisation", Keys.skill_climatisation),
    SOUDEUR_METALLIER("Soudeur métallier", Keys.skill_soudeur_metallier),
    CONDUCTEUR_DE_TRAVAUX("Conducteur de travaux", Keys.skill_conducteur_de_travaux),
    INGENIEUR_BTP("Ingénieur btp", Keys.skill_ingenieur_btp),
    TOPOGRAPHE("Topographe", Keys.skill_topographe),
    ETANCHEUR("Étancheur", Keys.skill_etancheur),
    MECANICIEN("Mécanicien", Keys.skill_mecanicien),
    PEINTRE("Peintre", Keys.skill_peintre),
    CARRELEUR("Carreleur", Keys.skill_carreleur),
    CORDISTE("Cordiste", Keys.skill_cordiste),
    CHEF_DE_CHANTIER("Chef de chantier", Keys.skill_chef_de_chantier),
    COFFREUR_BRANCHEUR("Coffreur/Bancheur", Keys.skill_coffreur_bancheur),
    RECEPTIONNISTE("Réceptionniste", Keys.skill_receptionniste),
    VOITURIER("Voiturier", Keys.skill_voiturier),
    STANDARDISTE("Standardiste", Keys.skill_standardiste),
    CONCIERGE("Concierge", Keys.skill_concierge),
    BAGAGISTE("Bagagiste", Keys.skill_bagagiste),
    VALET_DE_CHAMBRE("Valet de chambre", Keys.skill_valet_de_chambre),
    GOUVERNANTE("Gouvernante", Keys.skill_gouvernante),
    EQUIPIER_DETAGES("Équipier d\"étages", Keys.skill_equipier_detages),
    BIEN_ETRE("Bien être", Keys.skill_bien_etre),
    POLYVALENT("Polyvalent", Keys.skill_polyvalent),
    COURSIER("Coursier", Keys.skill_coursier),
    LIVREUR("Livreur", Keys.skill_livreur);

    companion object {
        fun fromName(name: String): SkillCatalog? =
            entries.firstOrNull { it.name == name }

        fun fromLabel(label: String): SkillCatalog? =
            entries.firstOrNull { it.label.equals(label.trim(), ignoreCase = true) }

        fun fromLabelKey(labelKey: String): SkillCatalog? =
            entries.firstOrNull { it.labelKey == labelKey }
    }
}